export const API_EXTERNAL_ENDPOINT = 'privacy-policy-page'

export const API_INTERNAL_ENDPOINT = 'strapi/privacy-policy-page'
